import React, { useEffect } from "react";

/* plugin */
import { useForm } from "react-hook-form";
import { motion } from "framer-motion";
/* plugin end */

/* service */
import formService from "../../services/formService";
/* service end */

/* component */
import ErrorMsgComp from "../../components/ErrorMsgComp";
import InnerBgComp from "../../components/InnerBgComp";
import AuthHeadingComp from "../../components/AuthHeadingComp";
import Header from "../../components/Header";
/* component end */

const ForgotPassword = () => {
  /* form */
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: "all",
  });
  /* form end */

  useEffect(() => {
    /* form service */
    formService.inputEmptyCheck();
    /* form service end */
  }, []);

  return (
    <div>
      {/* Header Starts */}
      <Header loginBtn={true} />
      {/* Header Ends */}

      {/* Main Container Starts */}
      <div className="main-container">
        <InnerBgComp bgImg={true} />

        {/* start */}
        <div className="comm-rev">
          <div className="container">
            {/* heading component */}
            <AuthHeadingComp />
            {/* heading component end */}

            {/* form */}
            <motion.div
              initial={{ y: 60, scale: 0.8, opacity: 0 }}
              animate={{ y: 0, scale: 1, opacity: 1 }}
              transition={{ duration: 0.5 }}
              className="form-box"
            >
              <div className="auth-hdn-box">
                <h2 className="auth-hdn">Forgot password?</h2>
                <div className="auth-para">
                  <p>
                    We’ll send instructions to your e-mail to reset {"\n"}
                    your password.
                  </p>
                </div>
              </div>
              <form onSubmit={handleSubmit()}>
                <div className="form-grp-field">
                  <div className="form-grp">
                    <input
                      className="form-field"
                      type="email"
                      id="emailaddress"
                      name="emailaddress"
                      {...register("emailaddress", {
                        required: "Email is required",
                        pattern: {
                          value: /[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/,
                          message: "Enter a valid Email",
                        },
                      })}
                    />
                    <p className="form-label">E-mail</p>
                  </div>
                  {errors.emailaddress && (
                    <ErrorMsgComp errorMessage={errors.emailaddress.message} />
                  )}
                </div>
                <button className="button button--block" type="submit">
                  <span>Send</span>
                </button>
              </form>
            </motion.div>
            {/* form end */}
          </div>
        </div>
        {/* end */}
      </div>
      {/* Main Container Ends */}
    </div>
  );
};

export default ForgotPassword;
